var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.458,
    height: 17.485,
    viewBox: "0 0 17.458 17.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#582bb8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 17.458,
    height: 17.485
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.132,7.552a1.031,1.031,0,0,0-.508-1.743l-4.793-.726h0L9.8.654a1.062,1.062,0,0,0-1.961,0L5.658,5.083h0L.793,5.809A1.031,1.031,0,0,0,.285,7.552L3.77,11.183v.073l-.8,4.865a1.127,1.127,0,0,0,1.6,1.234l4.067-2.324h.073l4.067,2.251a1.127,1.127,0,0,0,1.6-1.234l-.8-4.865V11.11Z",
    transform: "translate(0.021)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStarIcon);
export default __webpack_public_path__ + "static/media/blue-star-icon.6f497e19d46fecccab7d45f5de27eb26.svg";
export { ForwardRef as ReactComponent };